import {
  V10_AGENCY_EXPORT_SUITE,
  type V10AgencyExportCategory,
} from "../adapters/v10-agency-export-suite.js";
import { V10Btn } from "./V10Primitives.js";

export function V10AgencyExportSuite({
  departureKitReady,
  exportRunReady,
  onViewEvidence,
  onOpenApproval,
  onDownloadDepartureKit,
  onRequestRunExport,
}: {
  readonly departureKitReady: boolean;
  readonly exportRunReady: boolean;
  readonly onViewEvidence: () => void;
  readonly onOpenApproval: () => void;
  readonly onDownloadDepartureKit: () => void;
  readonly onRequestRunExport: () => void;
}) {
  const handlers: Record<V10AgencyExportCategory, () => void> = {
    evidence: onViewEvidence,
    approval: onOpenApproval,
    delivery: onDownloadDepartureKit,
    operational: onRequestRunExport,
  };

  return (
    <section className="v10-export-suite" aria-label="Agency export suite" data-testid="v10-agency-export-suite">
      <h3>Agency export suite</h3>
      <ul className="v10-export-suite-list">
        {V10_AGENCY_EXPORT_SUITE.map((entry) => {
          const disabled =
            (entry.category === "delivery" && !departureKitReady) ||
            (entry.category === "operational" && !exportRunReady);
          return (
            <li key={entry.id} data-testid={entry.id}>
              <strong>{entry.label}</strong>
              <p className="v10-muted">{entry.description}</p>
              <V10Btn variant="line" disabled={disabled} onClick={handlers[entry.category]}>
                {entry.actionLabel}
              </V10Btn>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
